import React, { forwardRef, useCallback } from 'react';

// ASSETS
import Svg from './assets/check-icon-white';

// COMPONENT
import Icon from '../Icon';

// ENUMS
import { CheckBoxType } from '../../enums/checkbox';

// INTERFACE
import { ICheckbox } from '../../interfaces/Checkbox.interface';

// STYLES
import {
  CheckboxHead,
  CheckboxHeadWrapper,
  CheckboxStyled,
  Description,
  IconContainer,
  IconWrapper,
  Input,
  Title
} from './styles';

// UTILS
import { renderHtml } from '../../utils/html';

const Checkbox: React.FC<ICheckbox> = forwardRef(
  (
    {
      checked,
      description,
      disabled = false,
      iconType,
      id,
      inModal = false,
      inputType,
      label,
      name,
      onChange,
      type = CheckBoxType.DEFAULT,
      value
    }: ICheckbox,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    const handleChange = useCallback(
      (e) => {
        if (!disabled && typeof onChange === 'function') {
          onChange(e);
        }
      },
      [onChange, disabled]
    );

    return (
      <CheckboxStyled id={id} htmlFor={name} checked={checked} disabled={disabled} inModal={inModal} type={type}>
        <Input
          checked={checked}
          disabled={disabled}
          id={name}
          name={name}
          onChange={(event) => handleChange(event)}
          ref={ref}
          type={inputType}
          value={value}
        />
        <IconContainer checked={checked} disabled={disabled} type={type}>
          <Svg />
        </IconContainer>
        <CheckboxHeadWrapper>
          {!!iconType && (
            <IconWrapper>
              <Icon type={iconType} />
            </IconWrapper>
          )}
          <CheckboxHead icon={!!iconType} type={type}>
            <Title disabled={disabled} type={type} icon={!!iconType} {...renderHtml(label)} />
            {description && type === CheckBoxType.LIST && <Description {...renderHtml(description)} />}
          </CheckboxHead>
        </CheckboxHeadWrapper>
      </CheckboxStyled>
    );
  }
);

export default Checkbox;
